import React, { useState } from 'react';
import '../styles/Convocatorias.css';

function Rendiciones(){

};
export default Rendiciones;